import { render } from "./SpaceDataTable.vue?vue&type=template&id=386d1e4d"
import script from "./SpaceDataTable.vue?vue&type=script&lang=js"
export * from "./SpaceDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__